export function getMapKeyByValue(map, value) {
  const entry = [...map].find(entry => entry[1] === value);
  return entry ? entry[0] : null;
}
